<script>
import Schedule from '@/components/seller/Schedule'

export default {
  name: 'OnboardingProfileSchedule',
  components: { Schedule },
  props: {
    user: { type: Object, required: true },
    submitting: { type: Boolean, default: () => false }
  },
  data() {
    return { pickedDates: {} }
  },
  computed: {
    // Get Allowed Times for Each Date
    allowedHours() {
      const times = []
      for (let i = 10; i < 22; i++) {
        times.push({ label: `${i}:00`, value: i })
      }
      return times
    }
  },
  created() {
    // Event tracking
    const { once } = this.lodash
    const { logEvent } = this.$amplitude

    this.scheduleSelected = once(() => {
      logEvent('Seller Onboarding: Schedule Selected')
    })

    // Prefill picked dates
    const { omit } = this.lodash
    this.pickedDates = omit(this.user.sellerSchedule, ['status', '__typename'])
  },
  methods: {
    submit() {
      const sellerSchedule = this.pickedDates
      this.$emit('submit', { sellerSchedule })
    }
  }
}
</script>

<template>
  <div class="view-grid">
    <!-- Onboarding Profile // Schedule -->
    <div class="onboarding-profile-schedule">
      <!-- Title -->
      <div class="display-1 font-weight-bold accent--text">
        Set a schedule
      </div>

      <!-- Subtitle -->
      <div class="title primary--text mt-3">
        Buyers will order food at least 24 hours in advance. You can change your
        cooking schedule at any time.
      </div>

      <Schedule v-model="pickedDates" @input="scheduleSelected" />

      <!-- Action Buttons -->
      <div class="my-5">
        <v-btn
          :loading="submitting"
          rounded
          outlined
          dark
          class="primary"
          @click="submit"
        >
          Continue
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.onboarding-profile-schedule
  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot
    margin: 0
</style>
